<template>
  <b-modal
    v-model="internalShow"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    content-class="modal-revised-evidence"
    size="lg"
    static
    @hide="onHide"
  >
    <div class="d-flex justify-content-end">
      <button type="button" class="close" aria-label="Close" @click="closeModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="success-container text-center">
      <div class="success-icon">
        <font-awesome-icon icon="check-circle" class="text-success" size="2x" />
      </div>
      <div class="header-text font-weight-bold">Evidence Saved Successfully!</div>
    </div>

    <div class="evidence-preview-card mb-4">
      <div class="part-header">
        <div class="part-title text-success font-weight-bold">{{ partTitle }}</div>
        <div class="post-title">{{ postTitle }}</div>
      </div>

      <hr />

      <div class="evidence-content mb-3">
        <div class="descriptions-section mb-4">
          <h6 class="font-weight-bold mb-2">Revised Evidence</h6>
          <base-text-editor-display v-if="postResponse.description" content-class="p-0">
            <div v-safe-html="postResponse.description" />
          </base-text-editor-display>
          <!-- empty state -->
          <div v-else class="empty-text-field"></div>
        </div>

        <!-- <div class="description-text" v-html="postResponse.description"></div> -->
        <div
          v-if="postResponse.attachments && postResponse.attachments.length"
          class="attachments-section"
        >
          <h6 class="font-weight-bold">Attachments ({{ postResponse.attachments.length }})</h6>
          <BaseFilesList :attachments="postResponse.attachments" :enable-delete="false" />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center footer-section">
      <div v-if="isShowFooterText">{{ footerText }}</div>
      <div v-else></div>
      <b-button variant="success" class="px-4" @click="onContinue">Continue</b-button>
    </div>
  </b-modal>
</template>

<script>
import BaseFilesList from '@/components/base-components/BaseFilesList.vue';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';

export default {
  name: 'ModalRevisedEvidence',
  components: {
    BaseFilesList,
    BaseTextEditorDisplay
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    postResponse: {
      type: Object,
      required: true
    },
    partTitle: {
      type: String,
      default: ''
    },
    postTitle: {
      type: String,
      default: ''
    },
    remainingParts: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      internalShow: this.show,
      isShowFooterText: this.remainingParts > 0,
      isWillHideFooterText: false
    };
  },
  computed: {
    footerText() {
      if (this.remainingParts === 0) {
        return 'You’re almost done!, Revise all evidence for consistency, then preview and submit.';
      }
      return 'Continue to revise the parts need improvement.';
    }
  },
  watch: {
    show(val) {
      this.internalShow = val;
    },
    internalShow(val) {
      if (!val) {
        this.$emit('close');
      }
    },
    remainingParts(newVal, oldVal) {
      if (newVal === 0 && oldVal === 1) {
        this.isWillHideFooterText = true;
      }
    }
  },
  methods: {
    closeModal() {
      this.hideFooterText();

      this.internalShow = false;
    },
    onHide(bvEvent) {
      if (bvEvent.trigger === 'backdrop' || bvEvent.trigger === 'esc') {
        bvEvent.preventDefault();
      }
    },
    onContinue() {
      this.hideFooterText();
      this.$emit('continue');
    },
    hideFooterText() {
      if (this.isWillHideFooterText && this.isShowFooterText) {
        this.isShowFooterText = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-revised-evidence {
  padding: 32px;
}
::v-deep .modal-body {
  padding: 0px;
}
.header-text {
  font-size: 24px;
  align-items: center;
}
.success-icon {
  color: #28a745;
  align-items: center;
}
.post-title {
  color: #28a745;
}
.success-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
}

.evidence-preview-card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;

  box-shadow: 0px 4px 10px 0px #7a7b9726;
  .evidence-content {
    max-height: 480px;
    overflow-y: auto;

    .empty-text-field {
      background-color: #eeeff8;
      border: 1px solid #d1d2db;
      border-radius: 4.64px;
      padding: 15px 12px;
      height: 6rem;
      width: 100%;
    }
  }
}

.description-text {
  font-size: 0.9rem;
}

.attachment-item {
  font-size: 0.9rem;
}

.footer-section {
  border-top: 1px solid #e9ecef;
  padding-top: 16px;
  margin-top: 16px;
}
</style>
